import React, { useEffect, useState } from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";

import CircularProgress from "@material-ui/core/CircularProgress";

import { PrizeSupplierService } from "services/prize/supplier/PrizeSupplier.service";

import { PrizeSupplier } from "models/prize/supplier/PrizeSupplier";

import Drawer from "components/common/drawer/Drawer";

import EditPrizeSupplier from "./Edit.template";

export type EditPrizeSupplierFormValues = {
  priceMargin: number;
  webhook: string;
};

const EditPrizeSupplierSchema = Yup.object().shape({
  priceMargin: Yup.number()
    .nullable()
    .min(0)
    .max(100),
  webhook: Yup.string().nullable()
});

function EditPrizeSupplierComponent({
  prizeSupplierService,
  drawerProps,
  action,
  ...props
}: {
  prizeSupplier: PrizeSupplier;
  prizeSupplierService: PrizeSupplierService;
  drawerProps?: any;
  action?: () => void;
}) {
  const [prizeSupplier, setPrizeSupplier] = useState<PrizeSupplier | null>(
    null
  );

  useEffect(() => {
    (async () => {
      const prizeSupplier = await prizeSupplierService.get(props.prizeSupplier);

      setPrizeSupplier(prizeSupplier);
    })();
  }, [props.prizeSupplier, prizeSupplierService]);

  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) =>
        prizeSupplier ? (
          <Formik
            enableReinitialize
            isInitialValid
            initialValues={{
              priceMargin: prizeSupplier.priceMargin,
              webhook: prizeSupplier.webhook
            }}
            validationSchema={EditPrizeSupplierSchema}
            onSubmit={(values: EditPrizeSupplierFormValues) =>
              prizeSupplierService
                .edit(prizeSupplier, {
                  ...values,
                  priceMargin: values.priceMargin && Number(values.priceMargin)
                })
                .then(close)
                .then(action)
            }
            render={(props: FormikProps<EditPrizeSupplierFormValues>) => (
              <EditPrizeSupplier
                formikProps={props}
                close={close}
                translationPath="prize.supplier.edit"
              />
            )}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <CircularProgress color="primary" />
          </div>
        )
      }
    />
  );
}

export default wire(["prizeSupplierService"], EditPrizeSupplierComponent);
